import { Component, OnDestroy } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { ProvidersServices } from "../../../providers/services";
import { DeliberyNoteServices } from "../../services";
import { IngredientsServices } from "../../../ingredients/services";
import { ProductsServices } from "../../../products/services";
import { Globals } from "../../../../globals";
import { FinishProcessPage } from '../../../finish-process/finish-process';
import { StaticsServices } from '../../../services/statics';
import { AnalyticsServices } from '../../../services/analyticsServices';

/**
 * Generated class for the DeliberyNoteCreateIngprodPricePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-delibery-note-create-ingprod-price',
  templateUrl: 'delibery-note-create-ingprod-price.html',
})
export class DeliberyNoteCreateIngprodPricePage implements OnDestroy {
  term: string;
  ingredient_measurement: any;
  delibery_note_uid: string;
  update_state: boolean = false;
  price_static: any;
  uid_provider: any;
  ingredient_name: any;
  provider_name: any;
  provider_uid: any;

  // Variables para totales generales
  subtotal: number = 0;
  totalTax: number = 0;
  total: number = 0;

  // Variable para prevenir múltiples ejecuciones
  public isProcessing: boolean = false;

  // Arrays auxiliares para cálculo por cajas (no se guardan en BD)
  public boxes: number[] = [];
  public unitsPerBox: number[] = [];

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public providersServices: ProvidersServices,
    public deliberyNoteServices: DeliberyNoteServices,
    public ingredientsServices: IngredientsServices,
    public productsServices: ProductsServices,
    public globals: Globals,
    public staticsServices: StaticsServices,
    private analyticsService: AnalyticsServices) {

    //this.ingredientsServices.getList(this.globals.restaurant_uid);
    //this.ingredient_measurement = this.navParams.get('ingredient_measurement');
    this.initTotals();
    this.delibery_note_uid = this.navParams.get('delibery_note_uid');
    this.update_state = this.navParams.get('update_state');
    this.provider_name = this.navParams.get('provider_name');
    this.provider_uid = this.navParams.get('provider_uid');
    //this.ingredient_name = this.navParams.get('ingredient_name');

    // Calcular totales iniciales
    this.calculateTotals();
    
    // Inicializar arrays auxiliares para cálculo por cajas
    this.initBoxCalculation();
  }

  ionViewWillLeave() {
    // Cerrar el loader si está abierto cuando el usuario va atrás
    this.dismissLoadingIfOpen();
  }

  ngOnDestroy() {
    // Limpieza adicional al destruir el componente
    this.dismissLoadingIfOpen();
  }

  dismissLoadingIfOpen() {
    if (this.loadingPopup) {
      try {
        this.loadingPopup.dismiss();
      } catch (error) {
        // El loader ya estaba cerrado o no existe
      }
    }
  }

  calculateRow(index) {
    var price_notax = this.deliberyNoteServices.prodings_array_tmp[index][3];
    var tax = this.deliberyNoteServices.prodings_array_tmp[index][5];
    var descom = this.deliberyNoteServices.prodings_array_tmp[index][7];

    var price_notaxca = this.deliberyNoteServices.calculatePrice(price_notax, this.deliberyNoteServices.prodings_array_tmp[index][6], this.deliberyNoteServices.prodings_array_tmp[index][4]);

    if (this.deliberyNoteServices.prodings_array_tmp[index][12] === 'discount_percentage') {
      price_notaxca = price_notaxca - ((price_notaxca * descom) / 100);
    } else {
      price_notaxca = price_notaxca - descom;
    }

    var total = price_notaxca + ((price_notaxca * tax) / 100);
    var total_sin_iva = price_notaxca;

    // Redondear a 2 decimales para evitar errores de precisión
    this.deliberyNoteServices.prodings_array_tmp[index][8] = Math.round(total * 100) / 100;
    this.deliberyNoteServices.prodings_array_tmp[index][10] = Math.round(total_sin_iva * 100) / 100;

    // Recalcular totales generales
    this.calculateTotals();
  }

  // Función para calcular totales generales
  calculateTotals() {
    if (!this.deliberyNoteServices.prodings_array_tmp || this.deliberyNoteServices.prodings_array_tmp.length === 0) {
      this.subtotal = 0;
      this.totalTax = 0;
      this.total = 0;
      return;
    }

    let newSubtotal = 0;
    let newTotal = 0;

    this.deliberyNoteServices.prodings_array_tmp.forEach(item => {
      // Usar los totales individuales ya calculados y redondeados
      if (item[8]) {
        newTotal += item[8]; // total con impuestos
      }
      if (item[10]) {
        newSubtotal += item[10]; // total sin impuestos
      }
    });

    // Redondear los totales a 2 decimales para evitar errores de precisión
    this.subtotal = Math.round(newSubtotal * 100) / 100;
    this.total = Math.round(newTotal * 100) / 100;

    // Calcular el impuesto como diferencia entre total y subtotal (igual que en la vista)
    this.totalTax = Math.round((this.total - this.subtotal) * 100) / 100;
  }


  delete(index) {
    this.deliberyNoteServices.prodings_array_tmp.splice(index, 1);
    // También eliminar de arrays auxiliares
    this.boxes.splice(index, 1);
    this.unitsPerBox.splice(index, 1);
    // Recalcular totales después de eliminar
    this.calculateTotals();
  }

  /**
   * Inicializar arrays auxiliares para cálculo por cajas
   */
  initBoxCalculation() {
    this.boxes = [];
    this.unitsPerBox = [];
    
    // Inicializar con valores vacíos para cada elemento
    for (let i = 0; i < this.deliberyNoteServices.prodings_array_tmp.length; i++) {
      this.boxes[i] = null;
      this.unitsPerBox[i] = null;
    }
  }

  /**
   * Calcular cantidad total a partir de cajas y unidades por caja
   */
  calculateFromBoxes(index: number) {
    const boxes = this.boxes[index];
    const unitsPerBox = this.unitsPerBox[index];
    
    // Solo calcular si ambos valores están presentes y son mayores a 0
    if (boxes && unitsPerBox && boxes > 0 && unitsPerBox > 0) {
      // Calcular cantidad total
      const totalUnits = boxes * unitsPerBox;
      
      // Actualizar el campo de cantidad (índice 6 del array)
      this.deliberyNoteServices.prodings_array_tmp[index][6] = totalUnits;
      
      // Recalcular el total del producto/ingrediente
      this.calculateRow(index);
      
      console.log(`[Cajas] ${boxes} cajas × ${unitsPerBox} uds/caja = ${totalUnits} unidades totales`);
    }
  }
  loadingPopup = this.loadingCtrl.create({
    spinner: 'crescent',
    content: 'Creando albarán...'
  });

  async update() {
    // Prevenir múltiples ejecuciones
    if (this.isProcessing) {
      return;
    }

    this.isProcessing = true;

    try {
      this.loadingPopup.present();

      // DEDUPLICACIÓN: Eliminar ingredientes/productos duplicados por UID
      const uniqueItems = new Map();
      for (let item of this.deliberyNoteServices.prodings_array_tmp) {
        const uid = item[0]; // UID del ingrediente/producto
        // Si el UID ya existe, mantener el primer elemento encontrado
        if (!uniqueItems.has(uid)) {
          uniqueItems.set(uid, item);
        } else {
          console.warn(`Elemento duplicado detectado y eliminado: ${item[1]} (UID: ${uid})`);
        }
      }

      // Convertir el Map a array para procesamiento
      const uniqueProdings = Array.from(uniqueItems.values());

      var _array = Array();
      var total_stock = 0;
      var elements = Array();

      for (var i = 0; uniqueProdings.length > i; i++) {
        //Hacemos push del elementos ha enviar a analytics
        elements.push({
          "uid_element": uniqueProdings[i][0],
          "name": uniqueProdings[i][1],
          "price": uniqueProdings[i][3] * uniqueProdings[i][6], //price * quantity
          "quantity": uniqueProdings[i][6],
          "measurement": uniqueProdings[i][4],
          "modifier": "",
        });
        //if ing or prod
        if (uniqueProdings[i][2] == 'ingredient') {//ingredient
          _array.push({
            discount: uniqueProdings[i][7],
            type_discount: uniqueProdings[i][12],
            measurement: uniqueProdings[i][4],
            name: uniqueProdings[i][1],
            price: uniqueProdings[i][3],
            total: uniqueProdings[i][8],
            quantity: uniqueProdings[i][6],
            tax: uniqueProdings[i][5],
            type: uniqueProdings[i][2],
            uid_ingredient: uniqueProdings[i][0],
            lots: uniqueProdings[i][11]
          });
          //
          total_stock += uniqueProdings[i][8];
          //set provider default
          this.providersServices.setIngredientDefault(
            uniqueProdings[i][0],
            this.provider_uid,
            this.provider_name,
            uniqueProdings[i][3],
            uniqueProdings[i][5],
            uniqueProdings[i][8]);
          //DataSet Update stock
          //saveDataSetStoctElement
          this.saveDataSetStoctElement(uniqueProdings[i][1],
            uniqueProdings[i][3],
            uniqueProdings[i][6],
            uniqueProdings[i][4],
            uniqueProdings[i][7],
            this.provider_name,
            'ingredient',
            uniqueProdings[i][5],
            uniqueProdings[i][9]);
          //update
          this.ingredientsServices.afs.collection('ingredients').doc(uniqueProdings[i][0]).update({
            'updated_at': new Date(),
          }).then(() => { });

        } else {//Product
          _array.push({
            discount: uniqueProdings[i][7],
            type_discount: uniqueProdings[i][12],
            measurement: uniqueProdings[i][4],
            name: uniqueProdings[i][1],
            price: uniqueProdings[i][3],
            total: uniqueProdings[i][8],
            quantity: uniqueProdings[i][6],
            tax: uniqueProdings[i][5],
            type: uniqueProdings[i][2],
            uid_product: uniqueProdings[i][0],
            lots: uniqueProdings[i][11]
          });
          //
          total_stock += uniqueProdings[i][8];
          //set provider default
          this.providersServices.setProductDefault(
            uniqueProdings[i][0],
            this.provider_uid,
            this.provider_name,
            uniqueProdings[i][3],
            uniqueProdings[i][5],
            uniqueProdings[i][8]);
          //DataSet Update stock
          //saveDataSetStoctElement
          this.saveDataSetStoctElement(uniqueProdings[i][1],
            uniqueProdings[i][3],
            uniqueProdings[i][6],
            uniqueProdings[i][4],
            uniqueProdings[i][7],
            this.provider_name,
            'product',
            uniqueProdings[i][5],
            uniqueProdings[i][9]);
          //upadte
          this.productsServices.afs.collection('products').doc(uniqueProdings[i][0]).update({
            'updated_at': new Date(),
          }).then(() => { });
        }
      }

      if (_array.length > 0) { //Controlamos que en array tenga como minimo algun elemento.
        //dataset

        // Redondear el total del stock a 2 decimales
        this.globals.dataSet('stock_deliberynote_total', Math.round(total_stock * 100) / 100, '', this.provider_name, '');
        //
        this.deliberyNoteServices.afs.collection('delibery_note').doc(this.delibery_note_uid).update({
          'list': _array,
          'state': 'completed',  // Marcar como completado
          'total': Math.round(total_stock * 100) / 100,
          'updated_at': new Date()
        }).then(() => {
          this.globals.GAtrackView('Stock', 'Stock - Delibery note - Select quantity price - Create', this.globals.restaurant.email, 'Create/Update', 'Create  select quantity price delibery note', 'Stock', '');
          if (this.update_state) {
          } else {
            //En ing/prod sumamos el stock y introducimos el nuevo precio
            this.getValuesToUpdate();
          }
        });
        //Creamos el array para stock analytics
        var stock = {
          "elements": elements,
          "uid": this.globals.restaurant_uid,
          "date": new Date(),
          "type": "stock",
          "comment": "",
          "type_type": "ALBARAN",
          "delivery_uid": this.delibery_note_uid
        };
        
        //Creamos el array para stock_purchases analytics
        var stock_purchases = {
          "uid": this.globals.restaurant_uid,
          "date": new Date(),
          "type": "stock_purchases",
          "delivery_uid": this.delibery_note_uid
        }
        
        //Enviamos a _data con manejo de errores mejorado
        try {
          const results = await Promise.all([
            this.analyticsService.sendStock(stock),
            this.analyticsService.sendStockPurchases(stock_purchases)
          ]);
          
          if (results.every(r => r === true)) {
          } else {
            console.warn(`[Albarán] Algunos analytics fallaron pero se guardaron en cola de reintentos`);
          }
        } catch (error) {
          console.error('[Albarán] Error crítico enviando analytics:', error);
          // Continuar aunque falle analytics - no bloquear al usuario
        }
      }

    } catch (error) {
      console.error('Error updating delivery note:', error);
      this.isProcessing = false;
      // Mostrar error al usuario si es necesario
      // Cerrar el loader en caso de error
      try {
        await this.loadingPopup.dismiss();
      } catch (dismissError) {
        // El loader ya estaba cerrado
      }
    }
    // NO cerrar el loader aquí - se cerrará en getValuesToUpdate()
  }

  //Función donde modificaremos los nuevos valores de stock y precio - OPTIMIZADA CON BATCH
  async getValuesToUpdate() {
    try {
      // OPTIMIZACIÓN: Recopilar todos los UIDs primero
      const ingredientUids = [];
      const productUids = [];

      for (let i = 0; this.deliberyNoteServices.prodings_array_tmp.length > i; i++) {
        const uid = this.deliberyNoteServices.prodings_array_tmp[i][0];
        const type = this.deliberyNoteServices.prodings_array_tmp[i][2];

        if (type === 'ingredient') {
          ingredientUids.push(uid);
        } else {
          productUids.push(uid);
        }
      }

      // OPTIMIZACIÓN: Obtener todos los documentos en batch
      const ingredientsMap = await this.getBatchDocuments('ingredients', ingredientUids);
      const productsMap = await this.getBatchDocuments('products', productUids);

      // Crear batch para todas las actualizaciones
      const batch = this.ingredientsServices.afs.firestore.batch();

      // Procesar todos los elementos
      for (let i = 0; this.deliberyNoteServices.prodings_array_tmp.length > i; i++) {
        const uid = this.deliberyNoteServices.prodings_array_tmp[i][0];
        const _stock = parseFloat(this.deliberyNoteServices.prodings_array_tmp[i][6]);
        const _newPrice = this.deliberyNoteServices.prodings_array_tmp[i][3];
        const _tax = this.deliberyNoteServices.prodings_array_tmp[i][5];
        const type = this.deliberyNoteServices.prodings_array_tmp[i][2];

        if (type === 'ingredient') {
          const ingredient = ingredientsMap[uid];
          if (ingredient) {
            const stock_ingr = _stock + parseFloat(ingredient.stock);

            for (let key in ingredient.providers) {
              if (ingredient.providers[key].default) {
                const _total_ingr = Math.round((_newPrice + (_newPrice * _tax / 100)) * 100) / 100;

                ingredient.providers[key].tax_static = _tax;
                ingredient.providers[key].price_static = _newPrice;
                ingredient.providers[key].pricetotal_static = _total_ingr;
                ingredient.providers[key].last_purchase = new Date();
              }
            }

            // Añadir al batch en lugar de update individual
            const docRef = this.ingredientsServices.afs.firestore.collection('ingredients').doc(uid);
            batch.update(docRef, {
              'stock': stock_ingr,
              'price_static': _newPrice,
              'providers': ingredient.providers,
            });

            // No bloquear el proceso con await para tracking (menos crítico)
            this.analyticsService.trackingExpStock('modify_stock', this.globals.tracking_exp['modify_stock'], uid).catch(err => {
              console.warn('[Albarán] Error tracking modify_stock (no crítico):', err);
            });
          }
        } else {
          const product = productsMap[uid];
          if (product) {
            const stock_prod = _stock + parseFloat(product.stock);

            for (let key in product.providers) {
              if (product.providers[key].default) {
                const _total_prod = Math.round((_newPrice + (_newPrice * _tax / 100)) * 100) / 100;
                product.providers[key].tax_static = _tax;
                product.providers[key].price_static = _newPrice;
                product.providers[key].pricetotal_static = _total_prod;
                product.providers[key].last_purchase = new Date();
              }
            }

            // Añadir al batch en lugar de update individual
            const docRef = this.productsServices.afs.firestore.collection('products').doc(uid);
            batch.update(docRef, {
              'stock': stock_prod,
              'price_static': _newPrice,
              'providers': product.providers,
            });

            // No bloquear el proceso con await para tracking (menos crítico)
            this.analyticsService.trackingExpStock('modify_stock', this.globals.tracking_exp['modify_stock'], uid).catch(err => {
              console.warn('[Albarán] Error tracking modify_stock (no crítico):', err);
            });
          }
        }
      }

      // OPTIMIZACIÓN: Commit de todas las actualizaciones en una sola operación
      await batch.commit();

    } catch (error) {
      console.error('Error in getValuesToUpdate:', error);
      this.isProcessing = false;
      // Cerrar el loader en caso de error
      try {
        await this.loadingPopup.dismiss();
      } catch (dismissError) {
        // El loader ya estaba cerrado
      }
      return; // Salir si hay error
    }

    this.staticsServices.changeStateStaticWait(true);

    // Cerrar el loader ahora que todo ha terminado
    try {
      await this.loadingPopup.dismiss();
    } catch (dismissError) {
      // El loader ya estaba cerrado
    }

    // Limpiar estado de sesión activa al finalizar
    this.deliberyNoteServices.clearCurrentDraft();

    // Resetear el flag antes de navegar
    this.isProcessing = false;

    if (this.navParams.get('origin') == 'provider_order') {
      this.navCtrl.setRoot(FinishProcessPage, {
        uid_element: this.delibery_note_uid,
        type: 'delibery_note',
        origin: 'provider_order',
      })
    } else {
      this.navCtrl.setRoot(FinishProcessPage, {
        uid_element: this.delibery_note_uid,
        type: 'delibery_note',
      })
    }
  }

  // NUEVO MÉTODO: Obtener múltiples documentos en una sola llamada
  async getBatchDocuments(collection: string, uids: string[]): Promise<{ [key: string]: any }> {
    if (uids.length === 0) {
      return {};
    }

    const firestore = this.ingredientsServices.afs.firestore;
    const docRefs = uids.map(uid => firestore.collection(collection).doc(uid));

    // Firestore getAll() puede manejar hasta 10 documentos por llamada
    // Si hay más, dividir en chunks
    const chunkSize = 10;
    const chunks = [];
    for (let i = 0; i < docRefs.length; i += chunkSize) {
      chunks.push(docRefs.slice(i, i + chunkSize));
    }

    const resultsMap: { [key: string]: any } = {};

    for (let chunk of chunks) {
      // Firebase v5 no tiene getAll(), usar Promise.all con get() individual
      const promises = chunk.map(docRef => docRef.get());
      const docs = await Promise.all(promises);
      docs.forEach((doc: firebase.firestore.DocumentSnapshot) => {
        if (doc.exists) {
          // Deep copy para evitar referencias compartidas entre objetos
          const data = JSON.parse(JSON.stringify(doc.data()));
          data.UID = doc.id;
          resultsMap[doc.id] = data;
        }
      });
    }

    return resultsMap;
  }

  // NOTA: updateNewValues ya no se usa - se reemplazó con batch operations en getValuesToUpdate

  initTotals() {
    for (var i = 0; this.deliberyNoteServices.prodings_array_tmp.length > i; i++) {
      //if ing or prod
      this.calculateRow(i);
    }
  }

  saveDataSetStoctElement(element_name, price, quantity, measurement, discount, provider, style, tax, pvp) {
    var extra = {
      "price": price,
      "quantity": quantity,
      "measurement": measurement,
      "discount": discount,
      "provider": provider,
      "style": style,
      "tax": tax,
    };
    this.globals.dataSet('stock_element', element_name, '', JSON.stringify(extra), '');
    //Add elements indv data log 
    if (style === 'ingredient') {//ingredient
      //Data
      this.globals.dataSet('ingredient_name', element_name, '', '');
      this.globals.dataSet('ingredient_price', price, '', element_name);
      var ingredient_provider_extra = {
        "product_name": element_name,
        "email": '',
        "address": '',
        "nif": '',
      };
      this.globals.dataSet('ingredient_provider', this.provider_name, '', JSON.stringify(ingredient_provider_extra), '');
      //Log
      this.globals.GAtrackView('Ingredients', 'Ingredients - Select providers - Update', this.globals.restaurant.email, 'Create/Update', 'Update select providers', 'Ingredients', element_name);
      this.globals.GAtrackView('Ingredients', 'Ingredients - Provider price - Update', this.globals.restaurant.email, 'Create/Update', 'Update provider price', 'Ingredients', element_name);

    } else {//product
      //Data
      this.globals.dataSet('product_name', element_name, '', '');
      this.globals.dataSet('product_price', element_name, '', pvp, '');
      this.globals.dataSet('product_cost', price, '', element_name);
      var product_provider_extra = {
        "product_name": element_name,
        "email": '',
        "address": '',
        "nif": '',
      };
      this.globals.dataSet('product_provider', this.provider_name, '', JSON.stringify(product_provider_extra), '');
      //Log
      this.globals.GAtrackView('Products', 'Products - Select providers - Update', this.globals.restaurant.email, 'Create/Update', 'Update select providers', 'Products', element_name);
      this.globals.GAtrackView('Products', 'Products - Price providers - Update', this.globals.restaurant.email, 'Create/Update', 'Update price providers', 'Products', element_name);
    }
  }

}


// WEBPACK FOOTER //
// ./src/pages/delibery_note/delibery-note-create/delibery-note-create-ingprod-price/delibery-note-create-ingprod-price.ts